import { apiRequest } from "../../api/apiRequest";
import { LOGOUT_ENDPOINT, USER_ENDPOINT } from "../../api/urls";

export const logoutCognito = () => {
    return apiRequest("POST", LOGOUT_ENDPOINT + "logout/");
};

export const fetchUser = () => {
    return apiRequest("GET", USER_ENDPOINT + "current/");
};
